import { Controller } from "@hotwired/stimulus"

// Journey missions cadence sub-filter (mobile parity — mobile CadenceChip).
//
// Writes the chosen cadence to `data-active-cadence` on the controller element
// (the journey page root). CSS hides mission rows whose `data-cadence` does not
// match. Driven by the single data attribute (not by mutating each row) so it
// mirrors the inventory rarity filter. Tapping the active cadence again clears
// it back to "all".
export default class extends Controller {
  static targets = ["chip"]

  select(event) {
    const tapped = event.currentTarget.dataset.cadence || "all"
    const current = this.element.dataset.activeCadence || "all"
    const next = tapped !== "all" && tapped === current ? "all" : tapped

    this.element.dataset.activeCadence = next
    this.chipTargets.forEach((chip) => {
      chip.classList.toggle(
        "journey-cadence-chip--active",
        (chip.dataset.cadence || "all") === next,
      )
    })
  }
}
